import React, { FC } from 'react';
import { Tabs, Tab, Box, Chip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { TFunction } from 'i18next';

const useStyles = makeStyles((theme: any) => ({
  tabsContainer: {
    marginBottom: theme.spacing(2),
  },
  tabs: {
    // MUI hides the auto scroll buttons below `sm`; keep them whenever the
    // filters overflow so every tab stays reachable without a swipe gesture.
    [theme.breakpoints.down('sm')]: {
      '& .MuiTabs-scrollButtonsDesktop': {
        display: 'inline-flex',
      },
    },
  },
  tabLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}));

type SettlementViewTabsProps = {
  viewMode: 'issues' | 'balanced' | 'all';
  onViewModeChange: (mode: 'issues' | 'balanced' | 'all') => void;
  issuesCount: number;
  balancedCount: number;
  allCount: number;
  t: TFunction;
};

export const SettlementViewTabs: FC<SettlementViewTabsProps> = ({
  viewMode,
  onViewModeChange,
  issuesCount,
  balancedCount,
  allCount,
  t,
}) => {
  const classes = useStyles();

  const handleChange = (_event: React.ChangeEvent<{}>, newValue: 'issues' | 'balanced' | 'all') => {
    onViewModeChange(newValue);
  };

  return (
    <Box className={classes.tabsContainer}>
      <Tabs
        className={classes.tabs}
        value={viewMode}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="settlement view options"
      >
        <Tab
          label={
            <Box className={classes.tabLabel}>
              {t('settlement:issues', 'Issues')}
              <Chip label={issuesCount} size="small" />
            </Box>
          }
          value="issues"
        />
        <Tab
          label={
            <Box className={classes.tabLabel}>
              {t('settlement:balanced', 'Balanced')}
              <Chip label={balancedCount} size="small" />
            </Box>
          }
          value="balanced"
        />
        <Tab
          label={
            <Box className={classes.tabLabel}>
              {t('settlement:all', 'All')}
              <Chip label={allCount} size="small" />
            </Box>
          }
          value="all"
        />
      </Tabs>
    </Box>
  );
};
